if (!customElements.get('uvi-bundle-contents')) {
  customElements.define(
    'uvi-bundle-contents',
    class UviBundleContents extends HTMLElement {
      connectedCallback() {
        this.formId = this.dataset.productFormId;
        this.moneyFormat = (window.FoxTheme && FoxTheme.settings && FoxTheme.settings.moneyFormat) || '{{amount}}';
        this.errorEl = this.querySelector('[data-uvi-bundle-error]');
        this.totalEl = this.querySelector('[data-uvi-bundle-total]');
        this.compareEl = this.querySelector('[data-uvi-bundle-compare]');
        this.submitEl = this.querySelector('[data-uvi-bundle-submit]');
        this.rows = Array.from(this.querySelectorAll('[data-uvi-bundle-row]'));

        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);

        this.addEventListener('change', this.onChange);
        this.addEventListener('input', this.onQtyInput);
        this.addEventListener('click', this.onQtyClick);
        this.addEventListener('click', this.onChipClick);
        if (this.submitEl) this.submitEl.addEventListener('click', this.onSubmit);

        this.onMainColorChange = this.onMainColorChange.bind(this);
        this.onVariantChanged = this.onVariantChanged.bind(this);
        document.addEventListener('change', this.onMainColorChange);
        document.addEventListener('variant:changed', this.onVariantChanged);

        if (window.FoxTheme && FoxTheme.pubsub) {
          this.variantUnsubscriber = FoxTheme.pubsub.subscribe(
            FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange,
            (event) => {
              this.syncFromMainForm();
              this.syncBundleColors(event && event.data && event.data.variant);
              this.updateTotal();
              window.requestAnimationFrame(() => this.updateTotal());
            }
          );
          if (FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange) {
            this.optionUnsubscriber = FoxTheme.pubsub.subscribe(
              FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange,
              (event) => {
                const target = event && event.data && event.data.target;
                const color = (target && (target.value || target.textContent)) || '';
                this.syncBundleColors({ option1: color, title: color });
                this.updateTotal();
              }
            );
          }
        }

        this.syncFromMainForm();
        this.syncBundleColors();
        this.applyDefaultSet();
        this._keepListedPrice = true;
        if (document.querySelector('uvi-bundle-contents') === this) this.bindMainAddToCart();
        this.updateTotal();
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.onChange);
        this.removeEventListener('input', this.onQtyInput);
        this.removeEventListener('click', this.onQtyClick);
        this.removeEventListener('click', this.onChipClick);
        if (this.submitEl) this.submitEl.removeEventListener('click', this.onSubmit);
        if (this.onMainAddClick) document.removeEventListener('click', this.onMainAddClick, true);
        if (this.variantUnsubscriber) this.variantUnsubscriber();
        if (this.optionUnsubscriber) this.optionUnsubscriber();
        document.removeEventListener('change', this.onMainColorChange);
        document.removeEventListener('variant:changed', this.onVariantChanged);
      }

      get cartDrawerEl() {
        return document.querySelector('cart-drawer');
      }

      get mainVariantInput() {
        if (!this.formId) return null;
        return document.querySelector(`#${this.formId} .product-variant-id, form#${this.formId} [name="id"]`);
      }

      rowKind(row) {
        return (row.dataset.kind || row.querySelector('.uvi-bundle__kind')?.textContent || '').trim();
      }

      rowMinQty(row) {
        return Math.max(0, Number(row.dataset.minQty || 0));
      }

      normalizeName(value) {
        return String(value || '')
          .toLocaleLowerCase('tr-TR')
          .replace(/ı/g, 'i')
          .replace(/i̇/g, 'i')
          .replace(/\u0307/g, '');
      }

      rowPackSize(row) {
        if (this.rowKind(row) === 'Tabure') return 2;
        const named = Number(row.dataset.packSize || 0);
        if (named > 1) return named;
        const name = this.normalizeName(row.querySelector('.uvi-bundle__name')?.textContent || '');
        if (/ikili|2['’′]?li|2\s*li|2-?li/.test(name)) return 2;
        if (/uclu|3['’′]?lu/.test(name)) return 3;
        return 1;
      }

      specText() {
        return this.normalizeName(`${this.dataset.setDesc || ''} ${this.dataset.setSpec || ''}`);
      }

      specMentions(kind) {
        const flag = {
          Sandalye: this.dataset.hasSandalye,
          Tabure: this.dataset.hasTabure,
          Bench: this.dataset.hasBench,
          Bank: this.dataset.hasBank,
        }[kind];
        if (flag === 'true') return true;
        if (flag === 'false') return false;
        const word = { Masa: 'masa', Sandalye: 'sandalye', Tabure: 'tabure', Bench: 'bench', Bank: 'bank' }[kind];
        return word ? this.specText().includes(word) : false;
      }

      specMentionsTabure() {
        return this.specMentions('Tabure');
      }

      countKind(word) {
        const matches = [...this.specText().matchAll(new RegExp(`(\\d+)\\s*${word}`, 'g'))];
        if (matches.length) {
          return matches.reduce((sum, match) => sum + Number(match[1] || 0), 0);
        }
        return this.specText().includes(word) ? 1 : 0;
      }

      extractCombos() {
        return [this.parseSetSpec()];
      }

      parseSetSpec() {
        return {
          Masa: this.countKind('masa') || 1,
          Sandalye: this.specMentions('Sandalye') ? this.countKind('sandalye') : 0,
          Tabure: this.specMentions('Tabure') ? this.countKind('tabure') : 0,
          Bench: this.specMentions('Bench') ? this.countKind('bench') : 0,
          Bank: this.specMentions('Bank') ? this.countKind('bank') : 0,
        };
      }

      specTotal(spec) {
        let total = 0;
        const used = {};
        this.querySelectorAll('[data-uvi-bundle-row]').forEach((row) => {
          const kind = this.rowKind(row);
          if (spec[kind] == null || used[kind]) return;
          used[kind] = true;
          const packQty = Math.round(Number(spec[kind]) / this.rowPackSize(row));
          total += Number(row.dataset.price || 0) * packQty;
        });
        return total;
      }

      rowDefaultQty(row) {
        const kind = this.rowKind(row);
        const liquidQty = Math.max(0, Number(row.dataset.defaultQty || 0));
        // Takım dışındaki ürünlerde satır adetleri Liquid tarafında belirleniyor:
        // ürünün kendi satırı 1, opsiyonel parçalar 0 ile başlar.
        if (this.dataset.isSet !== 'true' || row.dataset.isMain === 'true') {
          return liquidQty;
        }
        if (kind === 'Bank' || kind.startsWith('Modül')) return liquidQty;
        if (!this.specMentions(kind) && kind !== 'Masa') return 0;
        if (kind === 'Tabure') return 1;
        if (kind === 'Bench') return 1;
        if (kind === 'Masa') return 1;
        const spec = this._activeSpec || this.parseSetSpec();
        if (spec[kind] == null) return liquidQty;
        const specQty = Math.max(0, Math.round(Number(spec[kind]) / this.rowPackSize(row))) || 1;
        if (kind === 'Sandalye') return Math.max(liquidQty, specQty);
        return specQty;
      }

      applyDefaultSet() {
        this._activeSpec = this.parseSetSpec();
        // Takım dışındaki sayfalarda adetleri Liquid belirliyor: ürünün kendi satırı 1,
        // opsiyonel parçalar 0. Burada hiçbir şeye dokunmuyoruz.
        if (this.dataset.isSet !== 'true') return;
        const used = {};
        this.querySelectorAll('[data-uvi-bundle-row]').forEach((row) => {
          const kind = this.rowKind(row);
          if (!['Masa', 'Sandalye', 'Bench', 'Bank', 'Tabure', 'Modül 01', 'Modül 02', 'Modül'].includes(kind) || used[kind]) return;
          used[kind] = true;
          const qty = this.rowDefaultQty(row);
          const input = row.querySelector('[data-uvi-qty-input]');
          if (input) input.value = qty;
          this.setRowActive(row, qty > 0, qty);
        });
      }

      bindMainAddToCart() {
        if (this.mainCartBound) return;
        this.mainCartBound = true;
        this.onMainAddClick = (event) => {
          if (this._busy) {
            event.preventDefault();
            event.stopPropagation();
            return;
          }
          const inBundle = event.target.closest('uvi-bundle-contents');
          const addBtn = event.target.closest('.product-form__submit');
          const buyNow = event.target.closest(
            '.shopify-payment-button, .shopify-payment-button__button, shopify-accelerated-checkout, shopify-buy-it-now-button'
          );
          if (inBundle) return;
          if (!addBtn && !buyNow) return;
          if (addBtn && addBtn.closest('uvi-bundle-contents')) return;
          event.preventDefault();
          event.stopPropagation();
          if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
          this.onSubmit(event, { checkout: Boolean(buyNow) && !addBtn });
        };
        document.addEventListener('click', this.onMainAddClick, true);
      }

      syncMainPrice(total) {
        const listed = Number(this.dataset.listedPrice || 0);
        const display = this._keepListedPrice && listed > 0 ? listed : total;
        const root = document.querySelector('.product__info-container') || document;
        const formatted = this.formatMoney(display);
        const compareCents = Number(this.dataset.comparePrice || 0);
        root.querySelectorAll('.f-price__regular .f-price-item--regular, .f-price__sale .f-price-item--sale').forEach((el) => {
          if (el.closest('s, .uvi-bundle, uvi-bundle-contents')) return;
          el.textContent = formatted;
        });
        root.querySelectorAll('.f-price__sale .f-price-item--regular').forEach((el) => {
          if (el.closest('.uvi-bundle, uvi-bundle-contents')) return;
          const strike = el.querySelector('s') || el;
          if (compareCents > display) {
            el.hidden = false;
            el.style.display = '';
            strike.hidden = false;
            strike.style.display = '';
            strike.textContent = this.formatMoney(compareCents);
          } else {
            el.hidden = true;
            el.style.display = 'none';
          }
        });
        document.querySelectorAll('[data-uvi-set-summary]').forEach((box) => box.remove());
      }

      formatMoney(cents) {
        if (window.FoxTheme && FoxTheme.Currency && typeof FoxTheme.Currency.formatMoney === 'function') {
          return FoxTheme.Currency.formatMoney(cents, this.moneyFormat);
        }
        return (Number(cents) / 100).toFixed(2);
      }

      onChipClick = (event) => {
        const chip = event.target.closest('[data-uvi-chip]');
        if (!chip || chip.disabled) return;
        const row = chip.closest('[data-uvi-bundle-row]');
        const select = row && row.querySelector('[data-uvi-variant]');
        if (!select) return;
        select.value = chip.dataset.variantId;
        row.querySelectorAll('[data-uvi-chip]').forEach((item) => {
          item.classList.toggle('is-active', item === chip);
        });
        this.applyVariant(row, select);
        this.ensureChecked(row);
        this._keepListedPrice = false;
        this.updateTotal();
      };

      onQtyInput = (event) => {
        const input = event.target.closest('[data-uvi-qty-input]');
        if (!input) return;
        const row = input.closest('[data-uvi-bundle-row]');
        let value = Number(input.value || 0);
        value = Math.max(0, Math.min(20, value));
        input.value = value;
        this.setRowActive(row, value > 0, value);
        this._keepListedPrice = false;
        this.updateTotal();
      };

      onQtyClick = (event) => {
        const button = event.target.closest('[data-uvi-qty]');
        if (!button) return;
        const row = button.closest('[data-uvi-bundle-row]');
        const input = row && row.querySelector('[data-uvi-qty-input]');
        if (!input) return;
        let value = Number(input.value || 0);
        value = button.dataset.uviQty === 'plus' ? value + 1 : value - 1;
        value = Math.max(0, Math.min(20, value));
        input.value = value;
        this.setRowActive(row, value > 0, value);
        this._keepListedPrice = false;
        this.updateTotal();
      };

      onChange(event) {
        const row = event.target.closest('[data-uvi-bundle-row]');
        if (!row) return;

        if (event.target.matches('[data-uvi-variant]')) {
          this.applyVariant(row, event.target);
        }

        if (event.target.matches('[data-uvi-row-check]')) {
          this.toggleRow(row, event.target.checked);
        }

        this._keepListedPrice = false;
        this.updateTotal();
      }

      ensureChecked(row) {
        this.setRowActive(row, true);
      }

      setRowActive(row, checked, qtyValue) {
        const checkbox = row.querySelector('[data-uvi-row-check]');
        if (checkbox && !checkbox.disabled) checkbox.checked = checked;
        this.toggleRow(row, checked, qtyValue);
      }

      toggleRow(row, checked, qtyValue) {
        row.classList.toggle('is-checked', checked);
        row.classList.toggle('is-disabled', !checked);
        const qty = row.querySelector('[data-uvi-qty-input]');
        if (qty && qtyValue != null) qty.value = Math.max(0, Number(qtyValue));
        if (qty && !checked && qtyValue == null) qty.value = 0;
      }

      applyVariant(row, select) {
        const option = select.selectedOptions[0];
        if (!option) return;
        row.dataset.variantId = option.value;
        row.dataset.price = option.dataset.price || '0';
        row.dataset.comparePrice = option.dataset.comparePrice || option.dataset.price || '0';
        const available = option.dataset.available === 'true';
        row.dataset.available = available ? 'true' : 'false';

        const priceEl = row.querySelector('[data-uvi-row-price]');
        if (priceEl) {
          priceEl.innerHTML = `<span class="uvi-bundle__price-sale">${this.formatMoney(Number(row.dataset.price || 0))}</span>`;
        }

        const image = row.querySelector('[data-uvi-row-image]');
        if (image && option.dataset.image) image.src = option.dataset.image;
        if (option.dataset.url) {
          row.querySelectorAll('.uvi-bundle__media, .uvi-bundle__name').forEach((link) => {
            if (link && link.tagName === 'A') link.href = option.dataset.url;
          });
        }
        this.updateRowTitle(row, option.dataset.color || option.textContent);
      }

      stripFinishFromTitle(title) {
        return String(title || '')
          .replace(/\s*SEDEF\s+KREM/gi, '')
          .replace(/\s*KAR[İIıi]NA\s+ME[ŞŞşs]E\s+MASERAT[İIıi]\s*0?2?/gi, '')
          .replace(/\s*KAR[İIıi]NA\s+MASERAT[İIıi]\s*0?2?/gi, '')
          .replace(/\s*KAR[İIıi]NA\s+ME[ŞŞşs]E/gi, '')
          .replace(/\s*CEV[İIıi]Z\s+MASERAT[İIıi]\s*0?2?/gi, '')
          .replace(/\s*TRAVERTEN(\s+CEV[İIıi]Z)?/gi, '')
          .replace(/\s*MASERAT[İIıi]\s*0?2?/gi, '')
          .replace(/\s*YUVARLAK/gi, '')
          .replace(/\s*STORM[İIıi]/gi, '')
          .replace(/\s*SAB[İIıi]T/gi, '')
          .replace(/\s*ATLANT[İIıi]K(\s+ÇAM|\s+CAM)?/gi, '')
          .replace(/\s*BEYAZ/gi, '')
          .replace(/\s*CEV[İIıi]Z/gi, '')
          .replace(/\s*LUXE/gi, '')
          .replace(/\s*MDF/gi, '')
          .replace(/\s*KAHVE\s+K[ÖOöo][ŞŞşs]ES[İIıi]/gi, '')
          .replace(/\s*ME[ŞŞşs]E/gi, '')
          .replace(/\s{2,}/g, ' ')
          .trim();
      }

      prettyColor(color) {
        const raw = String(color || '').replace(/default\s*title/i, '').trim();
        const key = this.colorKey(raw);
        if (!raw || !key) return '';
        return raw;
      }

      updateRowTitle(row, color) {
        const nameEl = row.querySelector('[data-uvi-row-name]');
        if (!nameEl) return;
        const base = nameEl.dataset.baseTitle || nameEl.textContent;
        const cleaned = this.stripFinishFromTitle(base) || base;
        const pretty = this.prettyColor(color);
        nameEl.textContent = pretty ? `${cleaned} — ${pretty}` : cleaned;
      }

      productRoot() {
        return this.closest('product-info, .product, main') || document;
      }

      isFabricColor(value) {
        const key = this.colorKey(value);
        if (!key) return false;
        if (this.isWoodColor(value)) return false;
        if (key === 'krem') return this.dataset.colorMode !== 'wood';
        return /antrasit|navy|soho|yesil|fistik|fistık|maserati|gri|tas/.test(key);
      }

      shouldSyncRow(row, color) {
        const kind = this.rowKind(row);
        const fabric = this.isFabricColor(color);
        if (fabric && kind === 'Masa') return false;
        if (!fabric && kind !== 'Masa' && this.dataset.colorMode === 'wood') return false;
        return true;
      }

      syncFromMainForm() {
        const mainInput = this.mainVariantInput;
        const mainRow = this.querySelector('[data-uvi-bundle-row][data-is-main="true"]');
        if (!mainInput || !mainRow) return;
        const select = mainRow.querySelector('[data-uvi-variant]');
        if (select && mainInput.value) {
          select.value = mainInput.value;
          this.applyVariant(mainRow, select);
        } else if (mainInput.value) {
          mainRow.dataset.variantId = mainInput.value;
        }
      }

      onMainColorChange(event) {
        const target = event.target;
        if (!target) return;
        if (this.contains(target)) return;
        const root = this.productRoot();
        if (!root.contains(target)) return;
        const inVariantUi = target.closest('variant-selects, .product-form__input, product-info');
        if (!inVariantUi) return;
        if (!(target.matches('input[type="radio"], select') || target.closest('input[type="radio"]'))) return;
        const raw = target.value || (target.selectedOptions && target.selectedOptions[0] && target.selectedOptions[0].value) || '';
        if (!raw || /gid:\/\//.test(raw) || /^\d+$/.test(raw)) {
          this.syncBundleColors();
        } else {
          this.syncBundleColors({ option1: raw, title: raw });
        }
        this.updateTotal();
      }

      onVariantChanged(event) {
        const variant = event && event.detail && event.detail.variant;
        this.syncFromMainForm();
        this.syncBundleColors(variant);
        this.updateTotal();
      }

      colorKey(value) {
        return this.normalizeName(value)
          .replace(/[^a-z0-9çğıöşü\s]/gi, ' ')
          .replace(/\b(0?1|0?2|0?3|default|title|varsayilan)\b/g, '')
          .replace(/\s+/g, ' ')
          .trim();
      }

      isWoodColor(value) {
        const key = this.colorKey(value);
        return (
          key === 'mese' ||
          key === 'beyaz' ||
          key === 'ceviz' ||
          key === 'atlantik' ||
          key.includes('traverten') ||
          key.includes('atlantik')
        );
      }

      mainColorName(variant) {
        const root = this.productRoot();
        const label = root.querySelector('.product-form__input [data-selected-value]');
        const labelText = label ? (label.textContent || '').replace(/\s+/g, ' ').trim() : '';
        if (labelText && !/default/i.test(labelText)) return labelText;
        if (variant) {
          const fromVariant = variant.option1 || (variant.options && variant.options[0]) || variant.title || '';
          if (fromVariant && !/default/i.test(fromVariant)) return fromVariant;
        }
        const selected = root.querySelector('variant-selects [data-selected-variant]');
        if (selected) {
          try {
            const data = JSON.parse(selected.textContent);
            const fromJson = data.option1 || (data.options && data.options[0]) || data.title || '';
            if (fromJson && !/default/i.test(fromJson)) return fromJson;
          } catch (error) {
            /* ignore */
          }
        }
        const checked = root.querySelector(
          'variant-selects input[type="radio"]:checked, .product-form__input input[type="radio"]:checked'
        );
        if (checked && checked.value && !/gid:\/\//.test(checked.value) && !/^\d+$/.test(checked.value)) {
          return checked.value;
        }
        return '';
      }

      findOptionForColor(select, color) {
        const want = this.colorKey(color);
        if (!want || !select) return null;
        const options = Array.from(select.options);
        const exact = options.find((option) => this.colorKey(option.dataset.color || option.textContent) === want);
        if (exact) return exact;
        const tokens = want.split(' ').filter(Boolean);
        return options.find((option) => {
          const hay = this.colorKey(option.dataset.color || option.textContent);
          return tokens.every((token) => hay.includes(token));
        });
      }

      syncBundleColors(variant) {
        const color = this.mainColorName(variant);
        if (!color) return;
        this.querySelectorAll('[data-uvi-bundle-row]').forEach((row) => {
          if (!this.shouldSyncRow(row, color)) return;
          const select = row.querySelector('[data-uvi-variant]');
          if (!select || select.options.length < 2) {
            this.updateRowTitle(row, color);
            return;
          }
          const match = this.findOptionForColor(select, color);
          if (!match) {
            this.updateRowTitle(row, color);
            return;
          }
          select.value = match.value;
          this.applyVariant(row, select);
        });
      }

      getSelectedItems() {
        this.rows = Array.from(this.querySelectorAll('[data-uvi-bundle-row]'));
        this.syncFromMainForm();
        this.syncBundleColors();
        return this.rows
          .map((row) => {
            const qtyInput = row.querySelector('[data-uvi-qty-input]');
            const quantity = Math.max(0, Number(qtyInput && qtyInput.value ? qtyInput.value : 0));
            return {
              id: Number(row.dataset.variantId),
              quantity,
              pieces: quantity,
              price: Number(row.dataset.price || 0),
              compare: Number(row.dataset.comparePrice || row.dataset.price || 0),
              available: row.dataset.available !== 'false',
              isMain: row.dataset.isMain === 'true',
            };
          })
          .filter((item) => item.id && item.quantity > 0 && item.available);
      }

      updateTotal() {
        this.querySelectorAll('[data-uvi-bundle-row]').forEach((row) => {
          const lineEl = row.querySelector('[data-uvi-line-total]');
          const qtyInput = row.querySelector('[data-uvi-qty-input]');
          const priceEl = row.querySelector('[data-uvi-row-price]');
          const qty = Math.max(0, Number(qtyInput && qtyInput.value ? qtyInput.value : 0));
          const packPrice = Number(row.dataset.price || 0);
          if (priceEl) priceEl.innerHTML = `<span class="uvi-bundle__price-sale">${this.formatMoney(packPrice)}</span>`;
          if (lineEl) lineEl.textContent = this.formatMoney(packPrice * qty);
        });

        const items = this.getSelectedItems();
        const total = items.reduce((sum, item) => sum + Math.round(item.price) * item.quantity, 0);
        const compare = items.reduce((sum, item) => sum + Math.max(Math.round(item.compare), Math.round(item.price)) * item.quantity, 0);

        if (this.totalEl) this.totalEl.textContent = this.formatMoney(total);
        this.syncMainPrice(total);

        if (this.compareEl) {
          if (compare > total) {
            this.compareEl.hidden = false;
            this.compareEl.textContent = this.formatMoney(compare);
          } else {
            this.compareEl.hidden = true;
          }
        }

        if (this.submitEl) {
          this.submitEl.disabled = items.length === 0;
          this.submitEl.setAttribute('aria-disabled', items.length === 0 ? 'true' : 'false');
        }
      }

      showError(message) {
        if (!this.errorEl) return;
        if (!message) {
          this.errorEl.hidden = true;
          this.errorEl.textContent = '';
          return;
        }
        this.errorEl.hidden = false;
        this.errorEl.textContent = message;
      }

      async onSubmit(event, options = {}) {
        if (event && typeof event.preventDefault === 'function') event.preventDefault();
        if (this._busy) return;
        this.showError();
        const items = this.getSelectedItems();
        if (!items.length) return;

        const payloadItems = items.map((item) => ({
          id: item.id,
          quantity: item.quantity,
          properties: item.isMain
            ? { _bundle: this.dataset.productId || '' }
            : { _bundle: this.dataset.productId || '', _bundle_extra: '1' },
        }));

        this._busy = true;
        if (this.submitEl) {
          this.submitEl.classList.add('btn--loading');
          this.submitEl.setAttribute('aria-disabled', 'true');
        }

        try {
          let sectionsToBundle = [];
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
          );

          const config = FoxTheme.utils.fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          config.body = JSON.stringify({
            items: payloadItems,
            sections: sectionsToBundle,
            sections_url: window.location.pathname,
          });

          const response = await fetch(`${FoxTheme.routes.cart_add_url}`, config);
          const parsedState = await response.json();

          if (parsedState.status) {
            this.showError(parsedState.description || parsedState.message);
            return;
          }

          if (options.checkout) {
            const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
            window.location.href = new URL('checkout', window.location.origin + root).href;
            return;
          }

          const cartJson = await (await fetch(`${FoxTheme.routes.cart_url}`, { ...FoxTheme.utils.fetchConfig() })).json();
          cartJson.sections = parsedState.sections;

          if (FoxTheme.pubsub && FoxTheme.pubsub.publish) {
            FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
          }

          document.dispatchEvent(
            new CustomEvent('product-ajax:added', {
              detail: { product: parsedState },
            })
          );

          document.dispatchEvent(
            new CustomEvent('cart:refresh', {
              bubbles: true,
              detail: { open: true },
            })
          );

          if (document.body.classList.contains('cart-template') || FoxTheme.settings.cartType != 'drawer') {
            window.location.href = FoxTheme.routes.cart_url;
            return;
          }

          if (this.cartDrawerEl && typeof this.cartDrawerEl.show === 'function') {
            this.cartDrawerEl.show(this.submitEl);
          }
        } catch (error) {
          console.error(error);
          this.showError(FoxTheme.cartStrings && FoxTheme.cartStrings.error);
        } finally {
          this._busy = false;
          if (this.submitEl) {
            this.submitEl.classList.remove('btn--loading');
            this.submitEl.removeAttribute('aria-disabled');
          }
          this.updateTotal();
        }
      }
    }
  );
}

(function hideBundlerWidget() {
  const keepSel =
    'media-gallery, .product__media-wrapper, .product__media-gallery, .product-form, .product__title, .f-price, .product__inventory, .uvi-bundle-accordion, uvi-bundle-contents, .uvi-set-box';

  const hideNode = (node) => {
    if (!node || node.nodeType !== 1) return;
    if (node.closest && node.closest(keepSel)) return;
    if (node.matches && node.matches(keepSel)) return;
    node.style.setProperty('display', 'none', 'important');
    node.setAttribute('hidden', '');
  };

  const scan = () => {
    if (!document.body.classList.contains('product-template')) return;
    document
      .querySelectorAll(
        '.bndlr-container, .bundler-target-element, [class*="bndlr"], [id*="bndlr"], [id*="bundler"], [class*="fly-bundle"], [id*="fly-bundle"], [class*="FlyBundle"], [id*="aov_ai"], [class*="aov-ai"]'
      )
      .forEach(hideNode);
    document.querySelectorAll('.product__info-wrapper .shopify-app-block, .product__info-container .shopify-app-block').forEach((el) => {
      if (el.closest(keepSel)) return;
      const text = (el.innerText || '').replace(/\s+/g, ' ');
      if (text.includes('Takım İçeriğini Değiştir') || text.includes('Fly Bundle')) {
        hideNode(el);
      }
    });
  };

  let scanQueued = false;
  const queueScan = () => {
    if (scanQueued) return;
    scanQueued = true;
    window.requestAnimationFrame(() => {
      scanQueued = false;
      scan();
    });
  };

  document.addEventListener('bundler:bundle_widget_created', queueScan);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  window.addEventListener('load', scan);
  [400, 1200, 2500, 5000].forEach((ms) => setTimeout(scan, ms));
  if (window.MutationObserver) {
    new MutationObserver(queueScan).observe(document.body, { childList: true, subtree: true });
  }
})();

